var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":function($event){$event.preventDefault();return _vm.editRecord.apply(null, arguments)}}},[_c('vs-chip',{staticClass:"ag-grid-cell-chip",attrs:{"color":_vm.chipColor(_vm.params.value)}},[_c('span',[_vm._v(_vm._s(_vm.statusText(_vm.params.value)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }